import {
  AxiosExceptionHandler,
  RuntimeExceptionHandler,
} from '@ats/exceptions';
import { EXCEPTION_MESSAGES } from '@constants/exception';
import { isAxiosError } from 'axios';

export function useException() {
  const withLogger = (error: unknown) => {
    console.log('********************************');
    console.warn(error);
    console.log('********************************');

    if (isAxiosError(error)) {
      new AxiosExceptionHandler({
        error,
        message: EXCEPTION_MESSAGES.API_ERROR,
      });
    } else {
      new RuntimeExceptionHandler({
        error,
        message: EXCEPTION_MESSAGES.RUNTIME_ERROR,
      });
    }
  };

  const alertError = (error: unknown) => {
    if (isAxiosError(error) && error.response?.data.message)
      return alert(error.response?.data.message);

    alert('API 에러가 발생하였습니다.');
  };

  return { withLogger, alertError };
}
